import React from 'react';
import { connect } from 'react-redux';
import { PropTypes } from 'prop-types';
import { injectIntl } from 'react-intl';
import treeChanges from 'tree-changes';

import { Card, Collapse } from 'antd';
import CriteriaForm from './CriteriaForm';
import ReportTable from './ReportTable';

import StockAgingReportActions from '../../Stores/StockAgingReport/Actions';

const { Panel } = Collapse;

class StockAgingReportScreen extends React.PureComponent {
  componentDidMount() {
    const { curSiteFlowId, initStockAging } = this.props;

    if (curSiteFlowId > 0) {
      initStockAging();
    }
  }

  componentDidUpdate(prevProps) {
    const { curSiteFlowId, initStockAging } = this.props;
    const { changed } = treeChanges(prevProps, this.props);

    if (changed('curSiteFlowId')) {
      if (curSiteFlowId > 0) {
        initStockAging();
      }
    }
  }

  componentWillUnmount() {}

  render() {
    const { intl, match } = this.props;

    return (
      <Card title={intl.formatMessage({ id: 'stock_aging_report' })}>
        <Collapse defaultActiveKey={['2']}>
          <Panel header={intl.formatMessage({ id: 'criteria' })} key="1">
            <CriteriaForm match={match} />
          </Panel>
          <Panel header={intl.formatMessage({ id: 'report' })} key="2">
            <ReportTable match={match} />
          </Panel>
        </Collapse>
      </Card>
    );
  }
}

StockAgingReportScreen.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  intl: PropTypes.object,
  // eslint-disable-next-line react/forbid-prop-types
  match: PropTypes.object,

  initStockAging: PropTypes.func,
  curSiteFlowId: PropTypes.number
};

StockAgingReportScreen.defaultProps = {
  intl: {},
  match: {},

  initStockAging: {},
  curSiteFlowId: 0
};

const mapStateToProps = state => ({
  curSiteFlowId: state.app.curSiteFlowId
});

const mapDispatchToProps = dispatch => ({
  initStockAging: () => dispatch(StockAgingReportActions.stockAgingReportInitStockAging())
});

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(StockAgingReportScreen));
